import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useState } from 'react'

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {
  CardHeader,
  CardContent,
  MenuItem,
} from "@mui/material";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import Dropdown from 'components/CustomDropdown/Dropdown';



function AddTutor() {

 const[Type,setType] =  useState("")
 const[board,setboard] =  useState("")
 const[Class,setClass] =  useState("")
 const[Subject,setSubject] =  useState("")
 
  return (

   <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card
      sx={{
        boxShadow: 6,
        borderRadius: 4,
        overflow: "hidden",
        background: "linear-gradient(180deg, #fdfdff 0%, #f6f9fc 100%)",
      }}
    >
      {/* Header */}
      <CardHeader
        title={
          <ArgonTypography
            variant="h5"
            fontWeight="bold"
            color="primary"
            textTransform="uppercase"
          >
            🎥 Add Video Questions
          </ArgonTypography>
        }
        subheader={
          <ArgonTypography variant="body2" color="text.secondary">
            Fill in the details below to create engaging questions
          </ArgonTypography>
        }
        sx={{
          borderBottom: "2px solid #f0f0f0",
          background: "#fafafa",
          py: 2,
        }}
      />

      {/* Body */}
      <CardContent>
        <form>
          <Grid container spacing={3}>
            {/* Type */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Type
              </ArgonTypography>
              <Dropdown
                value={Type}
                onChange={(e) => setType(e.target.value)}
                options={["Video", "Audio", "Text"]}
                width="100%"
              />
            </Grid>

            {/* Board */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Board
              </ArgonTypography>
              <Dropdown
                value={board}
                onChange={(e) => setBoard(e.target.value)}
                options={["CBSE", "ICSE", "State Board"]}
                width="100%"
              />
            </Grid>

            {/* Class */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Class
              </ArgonTypography>
              <Dropdown
                value={Class}
                onChange={(e) => setClass(e.target.value)}
                options={["1","2","3","4","5","6","7","8","9","10","11","12"]}
                width="100%"
              />
            </Grid>

            {/* Subject */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Subject
              </ArgonTypography>
              <Dropdown
                value={Subject}
                onChange={(e) => setSubject(e.target.value)}
                options={["Math", "Science", "English", "History"]}
                width="100%"
              />
            </Grid>

            {/* Question Inputs */}
            {["Question 1", "Question 2", "Question 3", "Question 4"].map(
              (label, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <ArgonTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    color="text"
                    mb={1}
                  >
                    {label}
                  </ArgonTypography>
                  <ArgonInput
                    multiline
                    rows={3}
                    fullWidth
                    placeholder={`Enter ${label}`}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      "& .MuiInputBase-root": { borderRadius: "12px" },
                    }}
                  />
                </Grid>
              )
            )}
          </Grid>

          {/* Footer buttons */}
          <ArgonBox
            display="flex"
            justifyContent="flex-end"
            gap={2}
            mt={4}
          >
            <ArgonButton
              variant="outlined"
              color="secondary"
              href="/admin/videoquestionsmanagement"
              sx={{
                borderRadius: "12px",
                px: 3,
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="gradient"
              color="info"
              sx={{
                borderRadius: "12px",
                px: 4,
                fontWeight: "bold",
                boxShadow: "0px 4px 12px rgba(8,2,120,0.4)",
              }}
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </form>
      </CardContent>
    </Card>
        </ArgonBox>
      </ArgonBox>

             

      <Footer />
    </DashboardLayout>


  )
}

export default AddTutor